import { useContext } from 'react';
import UIContext from '../contexts/ui/UIContext';

export default function InfoPanel() {
  const { info } = useContext(UIContext);
  if (!info) return null;

  if (typeof info === 'object' && info !== null) {
    const parts = [];
    if (info.processType) parts.push(`${info.processType}`);
    if (info.seedType)    parts.push(`${info.seedType}`);
    if (info.harvestingProcedure)   parts.push(info.harvestingProcedure);
    if (info.tray)        parts.push(`TRAY ${info.tray}`);
    if (info.panel)       parts.push(`PANEL ${info.panel}`);
    if (info.plants != null) parts.push(`${info.plants} PLANT${info.plants === 1 ? '' : 'S'}`);

    return <div id="info-panel">{parts.join(' | ')}</div>;
  }

  return <div id="info-panel">{info}</div>;
}